export default __webpack_public_path__ + "static/media/arras01.0b9cdb36.jpg";